import { render } from "./CustomSwitchField.vue?vue&type=template&id=b6a7152a&scoped=true"
import script from "./CustomSwitchField.vue?vue&type=script&lang=js"
export * from "./CustomSwitchField.vue?vue&type=script&lang=js"

import "./CustomSwitchField.vue?vue&type=style&index=0&id=b6a7152a&lang=stylus&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6a7152a"]])

export default __exports__